import React from 'react';

export const Footer: React.FC = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="app-footer mt-auto">
            <div className="max-w-7xl mx-auto px-4 py-5 text-center">
                <p className="text-xs tracking-wide" style={{ color: 'var(--text-muted)' }}>
                    © {year} Execute &amp; Engrave LLC. All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
